import styled from 'styled-components';

export const Text = styled.p`
  margin: 0;
  padding: 0;
`;
